/**
 * Barre de filtres en chips pour la liste des dossiers TRA-EQ-131.
 *
 * La constante CHIPS (source de verite) est dans `../lib/filterChips.js` pour
 * etre testable sans bundler. On la re-exporte ici pour compat avec les imports
 * existants (`import { CHIPS } from './FilterChips.jsx'`).
 */

import { CHIPS } from '../lib/filterChips.js';

/**
 * @param {{
 *   active: string,
 *   counts: Record<string, number>,
 *   onSelect: (key: string, filter: object) => void,
 * }} props
 */
export default function FilterChips({ active, counts = {}, onSelect }) {
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {CHIPS.map((c) => {
        const isActive = c.key === active;
        const count = counts[c.key];
        return (
          <button
            key={c.key}
            onClick={() => onSelect(c.key, c.filter)}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
              isActive
                ? 'bg-[#0f172a] text-white'
                : 'bg-white text-[#475569] border border-gray-200 hover:bg-gray-50'
            }`}
          >
            {c.label}{typeof count === 'number' ? ` (${count})` : ''}
          </button>
        );
      })}
    </div>
  );
}

export { CHIPS };
